import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const emailUrl = CONTRACT_MANAGER_URL.EMAIL

const send = async (data) => {
  const url = `${emailUrl}/send`

  const result = await bService.post(url, data)
  return result
}

const sendBulk = async (data) => {
  const url = `${emailUrl}/send-bulk`

  const result = await bService.post(url, data)
  return result
}

const initData = async () => {
  const url = `${emailUrl}/init-data`

  const result = await bService.get(url)
  return result
}

const historyList = async (data) => {
  const url = `${emailUrl}/history-list`

  const result = await bService.post(url, data)
  return result
}

const historyResultList = async (historyId) => {
  const url = `${emailUrl}/${historyId}/history-result-list`

  const result = await bService.get(url)
  return result
}

export default {
  send,
  sendBulk,
  initData,
  historyList,
  historyResultList
}
